/**
 * Model to take care of AllOperators
 */
define('dataSource/customerDetails',['atn/atn', 'knockout', 'jquery', 'lodash', 'dataSource/session'],
    function(atn, ko, $, _, session) {
        'use strict';

        return {
            getCustomerDetails: getCustomerDetails
        };

        /**
         * fetches the latest customer details into customerDetails
         * @return {promise} promise object for fetching customerDetails
         */
        function getCustomerDetails() {
            var deferred = $.Deferred(),
                promise = $.ajax({
                    url: atn.config.api.customerInfo,
                    type: 'GET',
                    dataType: 'json'
                });

            promise.done(function(response) {
                deferred.resolve(response);
            });
            promise.fail(function(xhr) {
                deferred.reject(xhr);
            });

            return deferred.promise();
        }
    });

